module.exports = __webpack_public_path__ + "static/media/PositiveSelfTalk.2cba3597.vtt";